import React from 'react';

import Input from '../Input';
import normalize from './normalize';
import format from './format';
import validate from './validate';
import withSelectAll from '../withSelectAll';

function OrganisationNumberInput({ ...props }) {
  return (
    <Input
      {...props}
    />
  );
}

OrganisationNumberInput.format = v => v;
OrganisationNumberInput.normalize = v => v;
OrganisationNumberInput.validate = validate;

export default OrganisationNumberInput;
// withSelectAll(OrganisationNumberInput);
